import React from "react";
import { Route, Switch } from "react-router-dom";

import Home from "./Screens/Home/Home";
import Header from "./Screens/Header/Header";

import Footer from "./Screens/Footer/Footer";

import "./App.scss";

const App = () => {
  return (
    <>
      <div className="app_container">
        <Header />
        <Switch>
          <Route exact path="/" component={Home} />

          <Route path="/footer" component={Footer} />
        </Switch>
        <Footer />
      </div>
    </>
  );
};

export default App;
